export const environment = {
  production: false,
  version: '1.0',

  coreApi: {
    host: 'https://core-api-dev.lab.avyna.io',
  },

};
